import React, { Fragment } from "react";
import Footer from "./Footer";
import HeroPhoto from "./HeroPhoto"; // usa tu foto pequeña ya integrada
// Si prefieres la foto antigua: import foto from "../images/foto_perfil.jpg";

const Formacion = () => {
  const contactos = [
    { label: "Email", value: "koeman1976sf@gmail.com", href: "mailto:koeman1976sf@gmail.com" },
    { label: "Web", value: "joseanavas.com", href: "https://www.joseanavas.com" },
    { label: "LinkedIn", value: "Perfil", href: "https://www.linkedin.com/in/jose-antonio-navas-ruiz-25694859/" },
    { label: "X / Twitter", value: "@koeman1976", href: "https://twitter.com/koeman1976?s=09" },
  ];

  const formacion = [
     {
      titulo: "Curso Openai Azure",
      entidad: "Nallam",
      fecha: "Noviembre 2025",
      detalle:
        "Curso online (150h). Integrar OpenAI con los servicios en la nube de Azure para desarrollar proyectos prácticos en el ámbito de la inteligencia artificial",
    },
    {
      titulo: "Curso React Hooks",
      entidad: "Udemy",
      fecha: "Marzo 2020",
      detalle:
        "Curso online (34h). React Hooks, Gatsby/GraphQL, Firebase, Redux, Context, MERN, Next.js, Styled Components y Custom Hooks.",
    },
    {
      titulo: "MCTS (Microsoft Certified Technology Specialist)",
      entidad: "Microsoft",
      fecha: "Junio 2007",
      detalle: "Certificación para desarrollo de aplicaciones web y Windows.",
    },
    {
      titulo: "Master .NET",
      entidad: "Alhambra Eidos",
      fecha: "Octubre 2006 – Junio 2007",
      detalle: "Master en Desarrollo de Aplicaciones en .NET (173 horas).",
    },
    {
      titulo: "Curso de Páginas Web",
      entidad: "Universidad Politécnica de Madrid",
      fecha: "Enero – Abril 2006",
      detalle:
        "Curso de páginas web con JavaScript y DHTML en modalidad teleformación (153 horas).",
    },
    {
      titulo: "Informática de gestión",
      entidad: "E.S.I. Escuela de sistemas informáticos",
      fecha: "2002 – 2006",
      detalle: "",
    },
    {
      titulo: "Técnico Especialista en Electrónica",
      entidad: "I.F.P. Barajas",
      fecha: "1997",
      detalle: "Técnico especialista de grado superior en electrónica industrial.",
    },
  ];

  return (
    <Fragment>
      <main className="cvMain">
        {/* HERO SIMPLE (sin menú) */}
        <section className="cvHero cvHero2026">
          <div className="cvContainer cvHeroGrid">
            <div className="cvHeroLeft">
              <p className="cvKicker">Formación</p>
              <h1 className="cvTitle">Jose Antonio Navas</h1>
              <p className="cvSubtitle">Responsable IT / .NET Senior</p>

              <div className="cvMeta">
                <span className="cvMetaItem">Madrid</span>
                <span className="cvMetaDot" aria-hidden="true" />
                <span className="cvMetaItem">Operación · Arquitectura · Integración</span>
              </div>
            </div>

            <aside className="cvHeroRight" aria-label="Fotografía">
              <HeroPhoto />
              {/* Alternativa si quieres la foto antigua:
              <div className="heroPhoto"><img src={foto} alt="Jose A. Navas" /></div>
              */}
            </aside>
          </div>
        </section>

        {/* CONTENIDO EN 2 COLUMNAS (responsive) */}
        <section className="cvSection">
          <div className="cvContainer cvTwoCol">
            {/* Columna lateral */}
            <aside className="cvSide">
              <div className="cvCard">
                <h2 className="cvH2">Contacto</h2>
                <ul className="cvList">
                  {contactos.map((c) => (
                    <li key={c.label} className="cvListItem">
                      <span className="cvMuted">{c.label}:</span>{" "}
                      <a className="cvLink" href={c.href} target="_blank" rel="noreferrer">
                        {c.value}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="cvCard">
                <h2 className="cvH2">Dirección</h2>
                <p className="cvP">San Fernando de Henares</p>
                <p className="cvMuted">28830 · Madrid (España)</p>
              </div>

              <div className="cvCard">
                <h2 className="cvH2">Idiomas</h2>
                <ul className="cvList">
                  <li className="cvListItem">Español <span className="cvMuted">(Nativo)</span></li>
                  <li className="cvListItem">Inglés <span className="cvMuted">(Medio/Alto)</span></li>
                </ul>
              </div>
            </aside>

            {/* Columna principal */}
            <div className="cvContent">
              <div className="cvSectionHead">
                <h2 className="cvH2">Formación y certificaciones</h2>
                <p className="cvMuted">Resumen de formación relevante y certificaciones.</p>
              </div>

              <div className="cvTimeline">
                {formacion.map((f) => (
                  <article key={f.titulo} className="cvCard cvItem">
                    <div className="cvItemHead">
                      <div>
                        <h3 className="cvH3">{f.titulo}</h3>
                        <p className="cvMuted">{f.entidad}</p>
                      </div>
                      <div className="cvTag">{f.fecha}</div>
                    </div>
                    {f.detalle ? <p className="cvP">{f.detalle}</p> : null}
                  </article>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </Fragment>
  );
};

export default Formacion;
